/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps, import/no-anonymous-default-export, no-useless-escape */
import React,{useState,useEffect,useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SlidePanel from '../components/common/SlidePanel';
import Badge from '../components/common/Badge';
import {Input,Select} from '../components/common/FormField';
import api from '../services/api';
import {fmtDate} from '../utils/helpers';

const STATUS_COLORS:Record<string,string>={
  SCHEDULED:'bg-blue-100 text-blue-800',PRESENT:'bg-green-100 text-green-800',
  ABSENT:'bg-red-100 text-red-700',LEAVE:'bg-gray-200 text-gray-600',
  HOLIDAY:'bg-yellow-100 text-yellow-700',OFF:'bg-slate-100 text-slate-400',
  EMERGENCY:'bg-orange-100 text-orange-700',
};
const STATUS_DOT:Record<string,string>={
  SCHEDULED:'🔵',PRESENT:'🟢',ABSENT:'🔴',LEAVE:'⚫',HOLIDAY:'⚪',OFF:'⚪',EMERGENCY:'🟣',
};

function getWeekDates(startDate:string){
  const dates:string[]=[];
  const d=new Date(startDate);
  for(let i=0;i<7;i++){
    dates.push(d.toISOString().split('T')[0]);
    d.setDate(d.getDate()+1);
  }
  return dates;
}

function todayStr(){return new Date().toISOString().split('T')[0];}

export default function DutyRosterPage(){
  const [tab,setTab]=useState<'roster'|'shifts'|'holidays'|'bulk'|'audit'>('roster');
    const [filterDoctor,setFilterDoctor]=useState('');
  const DEPARTMENTS=['General Medicine','Surgery','Orthopaedics','Gynaecology','Paediatrics','Cardiology','Neurology','ENT','Ophthalmology','Emergency','ICU','Radiology','Laboratory'];
  const [bulkForm,setBulkForm]=useState({
    doctorIds:[] as string[],shiftId:'',fromDate:todayStr(),toDate:todayStr(),
    recurringType:'DAILY',skipHolidays:true,remarks:'',status:'SCHEDULED',
    oldShiftId:'',
    newShiftId:'',
    assignedBy:'',
    outgoingNurseId:'',
    incomingNurseId:'',
    patientSummaries:'',
    criticalPatients:'',
    newAdmissions:'',
    pendingTasks:'',
    handoverTime:'',
    handoverAccepted:false
  });
  const [weekStart,setWeekStart]=useState(()=>{
    const d=new Date(); d.setDate(d.getDate()-d.getDay()+1); return d.toISOString().split('T')[0];
  });
  const [grid,setGrid]=useState<any[]>([]);
  const [shifts,setShifts]=useState<any[]>([]);
  const [holidays,setHolidays]=useState<any[]>([]);
  const [doctors,setDoctors]=useState<any[]>([]);
  const [dashboard,setDashboard]=useState<any>({});
  const [audit,setAudit]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const notify=(m:string)=>{setMsg(m);setTimeout(()=>setMsg(''),4000);};

  // Cell editor
  const [editCell,setEditCell]=useState<any>(null);
  const [cellForm,setCellForm]=useState({shiftId:'',status:'SCHEDULED',remarks:'',isEmergency:false});
  const [conflictInfo,setConflictInfo]=useState<any>(null);

  // Shift form
  const [showShiftForm,setShowShiftForm]=useState(false);
  const [shiftForm,setShiftForm]=useState({shiftName:'',shiftCode:'',startTime:'09:00',endTime:'13:00',slotDurationMinutes:15,maxPatients:20,overbookingLimit:0,color:'#3B82F6',consultationType:'OPD'});
  const [editShiftId,setEditShiftId]=useState<string|null>(null);

  // Holiday form
  const [showHolidayForm,setShowHolidayForm]=useState(false);
  const [holidayForm,setHolidayForm]=useState({holidayName:'',holidayDate:'',holidayType:'NATIONAL'});

  // Absent form
  const [showAbsentForm,setShowAbsentForm]=useState(false);
  const [absentForm,setAbsentForm]=useState({rosterId:'',doctorName:'',reason:''});

  // Emergency override form
  const [showEmergencyForm,setShowEmergencyForm]=useState(false);
  const [emergencyForm,setEmergencyForm]=useState({doctorId:'',shiftId:'',rosterDate:todayStr(),reason:''});

  // Bulk assign
  const [filterDept,setFilterDept]=useState('');
    
  const weekDates=getWeekDates(weekStart);

  const load=useCallback(async()=>{
    setLoading(true);
    try{
      const [g,s,h,d,db]=await Promise.all([
        api.getRosterGrid({fromDate:weekDates[0],toDate:weekDates[6],departmentId:filterDept||undefined,doctorId:filterDoctor||undefined}),
        api.getRosterShifts(),
        api.getHolidays(),
        api.getDoctors(),
        api.getRosterDashboard(todayStr()),
      ]);
      setGrid(g.data?.grid||[]);
      setShifts(s.data||[]);
      setHolidays(h.data||[]);
      setDoctors(d.data||[]);
      setDashboard(db.data||{});
    }catch{}
    setLoading(false);
  },[weekStart,filterDept,filterDoctor]);

  useEffect(()=>{load();},[load]);

  useEffect(()=>{
    if(tab==='audit') api.getRosterAudit().then(r=>setAudit(r.data||[])).catch(()=>{});
  },[tab]);

  const openCellEditor=(doctor:any,date:string,existing:any)=>{
    setEditCell({doctor,date,existing});
    setCellForm({
      shiftId:existing?.shift_id||existing?.shiftId||'',
      status:existing?.status||'SCHEDULED',
      remarks:existing?.remarks||'',
      isEmergency:existing?.is_emergency||false,
    });
  };

  const saveCellEntry=async()=>{
    if(!editCell)return;
    // Check for conflicts first
    if(cellForm.shiftId&&cellForm.status==='SCHEDULED'){
      try{
        const conflict=await api.checkRosterConflict(editCell.doctor.id,editCell.date,cellForm.shiftId);
        if(conflict.data?.hasConflict){
          setConflictInfo({...conflict.data,doctor:editCell.doctor,date:editCell.date,pendingForm:cellForm});
          return;
        }
      }catch{}
    }
    await doSaveEntry(cellForm);
  };

  const doSaveEntry=async(form:any)=>{
    if(!editCell)return;
    setSaving(true);
    try{
      await api.createRosterEntry({
        doctorId:editCell.doctor.id,shiftId:form.shiftId||undefined,
        rosterDate:editCell.date,status:form.status,
        remarks:form.remarks,isEmergency:form.isEmergency,
      });
      // Auto-generate slots after scheduling
      if(form.shiftId&&form.status==='SCHEDULED'){
        api.generateSlots({doctorId:editCell.doctor.id,date:editCell.date,shiftId:form.shiftId}).catch(()=>{});
      }
      notify('✅ Roster updated!');setEditCell(null);setConflictInfo(null);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const markAbsentWithNotif=async()=>{
    if(!absentForm.rosterId||!absentForm.reason){notify('Enter reason');return;}
    setSaving(true);
    try{
      const r=await api.markDoctorAbsent(absentForm.rosterId,{reason:absentForm.reason});
      notify(`✅ Marked absent — ${r.data?.affectedAppointments||0} appointment(s) flagged for rescheduling`);
      setShowAbsentForm(false);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const doEmergencyOverride=async()=>{
    if(!emergencyForm.doctorId||!emergencyForm.shiftId||!emergencyForm.reason){notify('Fill all fields');return;}
    setSaving(true);
    try{
      await api.emergencyRosterOverride(emergencyForm);
      notify('✅ Emergency duty assigned!');setShowEmergencyForm(false);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const copyLastWeek=async()=>{
    const sourceStart=new Date(weekStart);sourceStart.setDate(sourceStart.getDate()-7);
    const sourceEnd=new Date(weekStart);sourceEnd.setDate(sourceEnd.getDate()-1);
    setSaving(true);
    try{
      const r=await api.copyRoster({
        sourceFrom:sourceStart.toISOString().split('T')[0],
        sourceTo:sourceEnd.toISOString().split('T')[0],
        targetFrom:weekStart,
      });
      notify(`✅ Copied ${r.data?.copied||0} roster entries from last week`);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const copyLastMonth=async()=>{
    const d=new Date(weekStart);
    const sourceStart=new Date(d.getFullYear(),d.getMonth()-1,1);
    const sourceEnd=new Date(d.getFullYear(),d.getMonth(),0);
    const targetStart=new Date(d.getFullYear(),d.getMonth(),1);
    setSaving(true);
    try{
      const r=await api.copyRoster({
        sourceFrom:sourceStart.toISOString().split('T')[0],
        sourceTo:sourceEnd.toISOString().split('T')[0],
        targetFrom:targetStart.toISOString().split('T')[0],
      });
      notify(`✅ Copied ${r.data?.copied||0} roster entries from last month`);await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const deleteEntry=async(id:string)=>{
    if(!window.confirm('Delete this roster entry?'))return;
    await api.deleteRosterEntry(id);
    notify('Deleted'); await load();
  };

  const saveShift=async()=>{
    setSaving(true);
    try{
      if(editShiftId) await api.updateRosterShift(editShiftId,shiftForm);
      else await api.createRosterShift(shiftForm);
      notify('✅ Shift saved!');
      setShowShiftForm(false); setEditShiftId(null);
      const r=await api.getRosterShifts(); setShifts(r.data||[]);
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const saveHoliday=async()=>{
    setSaving(true);
    try{
      await api.addHoliday(holidayForm);
      notify('✅ Holiday added!'); setShowHolidayForm(false);
      const r=await api.getHolidays(); setHolidays(r.data||[]);
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const saveBulkAssign=async()=>{
    if(!bulkForm.doctorIds.length){notify('Select at least one doctor');return;}
    if(!bulkForm.shiftId){notify('Select a shift');return;}
    setSaving(true);
    try{
      const r=await api.bulkAssignRoster(bulkForm);
      notify(`✅ Assigned ${r.data?.assigned||0} roster entries!`);
      await load();
    }catch(e:any){notify('❌ '+(e.response?.data?.message||'Error'));}
    setSaving(false);
  };

  const TABS=[['roster','📅 Roster Grid'],['shifts','⏱️ Shift Master'],['holidays','🏖️ Holidays'],['bulk','📋 Bulk Assign'],['audit','🔍 Audit Log']];

  return(
    <Layout title="Duty Roster Management">
      {msg&&<div className="fixed top-4 right-4 bg-white border shadow-lg rounded-xl px-4 py-3 text-sm z-50">{msg}</div>}

      {/* Dashboard quick stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {[['On Duty Today',dashboard.onDuty,'🟢'],['Absent',dashboard.absent,'🔴'],['On Leave',dashboard.onLeave,'⚫'],['Slots Booked',`${dashboard.bookedSlots||0}/${dashboard.totalSlots||0}`,'📅']].map(([l,v,ic])=>(
          <div key={String(l)} className="card p-3 flex items-center gap-3">
            <span className="text-2xl">{ic}</span>
            <div><p className="text-xs text-slate-400">{l}</p><p className="text-xl font-bold text-slate-800">{v||0}</p></div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 bg-slate-100 p-1 rounded-xl w-fit flex-wrap">
        {TABS.map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t as any)} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${tab===t?'bg-white shadow text-[#02357A]':'text-slate-600 hover:text-slate-800'}`}>{l}</button>
        ))}
      </div>

      {/* ROSTER GRID TAB */}
      {tab==='roster'&&(
        <div>
          <div className="flex items-center gap-3 mb-3 flex-wrap">
            {/* Week navigation */}
            <div className="flex items-center gap-2">
              <button onClick={()=>{const d=new Date(weekStart);d.setDate(d.getDate()-7);setWeekStart(d.toISOString().split('T')[0]);}} className="btn-secondary text-xs py-1 px-2">◀ Prev</button>
              <Input type="date" value={weekStart} onChange={e=>{const d=new Date(e.target.value);d.setDate(d.getDate()-d.getDay()+1);setWeekStart(d.toISOString().split('T')[0]);}} className="text-xs w-36"/>
              <button onClick={()=>{const d=new Date(weekStart);d.setDate(d.getDate()+7);setWeekStart(d.toISOString().split('T')[0]);}} className="btn-secondary text-xs py-1 px-2">Next ▶</button>
              <button onClick={()=>{const d=new Date();d.setDate(d.getDate()-d.getDay()+1);setWeekStart(d.toISOString().split('T')[0]);}} className="text-xs text-[#02357A] hover:underline">Today</button>
            </div>
            {/* Filters */}
            <select value={filterDept} onChange={e=>setFilterDept(e.target.value)} className="input text-xs w-44 py-1">
              <option value="">All Departments</option>
              {DEPARTMENTS.map(d=><option key={d}>{d}</option>)}
            </select>
            <select value={filterDoctor} onChange={e=>setFilterDoctor(e.target.value)} className="input text-xs w-44 py-1">
              <option value="">All Doctors</option>
              {doctors.map((d:any)=><option key={d.id} value={d.id}>{d.firstName||d.first_name} {d.lastName||d.last_name}</option>)}
            </select>
            {/* Copy actions */}
            <button onClick={copyLastWeek} disabled={saving} className="btn-secondary text-xs py-1 px-2">📋 Copy Last Week</button>
            <button onClick={copyLastMonth} disabled={saving} className="btn-secondary text-xs py-1 px-2">📅 Copy Last Month</button>
            {/* Emergency override */}
            <button onClick={()=>{setEmergencyForm({doctorId:'',shiftId:'',rosterDate:weekStart,reason:''});setShowEmergencyForm(true);}} className="text-xs py-1 px-2 bg-red-100 text-red-700 hover:bg-red-200 rounded-lg font-medium transition-colors">🚨 Emergency Override</button>
            <div className="ml-auto flex gap-1 flex-wrap text-xs">
              {Object.entries(STATUS_DOT).map(([s,d])=><span key={s} className="text-slate-500">{d} {s}</span>)}
            </div>
          </div>

          {loading?<div className="card p-8 text-center text-slate-400">Loading roster...</div>:(
            <div className="card overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 border-b">
                  <tr>
                    <th className="text-left p-3 font-semibold text-slate-600 min-w-40">Doctor</th>
                    {weekDates.map(d=>{
                      const hol=holidays.find((h:any)=>h.holiday_date?.split('T')[0]===d||h.holidayDate===d);
                      return(
                        <th key={d} className={`text-center p-2 font-medium text-xs min-w-28 ${hol?'bg-yellow-50':d===todayStr()?'bg-blue-50':''}`}>
                          <p className="text-slate-700">{new Date(d+'T12:00:00').toLocaleDateString('en-IN',{weekday:'short'})}</p>
                          <p className="text-slate-500 font-normal">{new Date(d+'T12:00:00').toLocaleDateString('en-IN',{day:'2-digit',month:'short'})}</p>
                          {hol&&<p className="text-yellow-600 text-xs">🏖️ {hol.holiday_name}</p>}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {grid.map((row:any)=>{
                    return(
                    <tr key={row.doctor.id} className="hover:bg-slate-50 group">
                      <td className="p-3 sticky left-0 bg-white group-hover:bg-slate-50 border-r border-slate-100">
                        <p className="font-semibold text-slate-800 text-sm">{row.doctor.first_name} {row.doctor.last_name}</p>
                        <p className="text-xs text-slate-400">{row.doctor.designation||'Doctor'}</p>
                      </td>
                      {weekDates.map(d=>{
                        // Normalize date key — backend returns full timestamp
                        const dayKey=Object.keys(row.days||{}).find(k=>k.startsWith(d));
                        const entry=row.days[d]||(dayKey?row.days[dayKey]:null);
                        const hol=holidays.find((h:any)=>h.holiday_date?.split('T')[0]===d);
                        const isToday=d===todayStr();
                        return(
                          <td key={d} className={`p-1 border-r border-slate-100 last:border-r-0 ${hol?'bg-yellow-50':isToday?'bg-blue-50/40':''}`}>
                            {entry?(
                              <div
                                onClick={()=>openCellEditor(row.doctor,d,entry)}
                                className={`cursor-pointer rounded-lg p-2 text-xs font-medium transition-all hover:shadow-md ${STATUS_COLORS[entry.status]||'bg-slate-100 text-slate-700'}`}
                                style={{borderLeft:`4px solid ${entry.color||'#94a3b8'}`}}
                                title="Click to edit"
                              >
                                <p className="font-bold leading-tight truncate">{entry.shift_name||entry.status}</p>
                                {entry.start_time&&<p className="opacity-80 leading-tight">{entry.start_time?.slice(0,5)}–{entry.end_time?.slice(0,5)}</p>}
                                <span className={`inline-block text-xs px-1 rounded font-semibold mt-1 ${
                                  entry.status==='PRESENT'?'bg-green-200 text-green-800':
                                  entry.status==='ABSENT'?'bg-red-200 text-red-800':
                                  entry.status==='LEAVE'?'bg-slate-200 text-slate-700':
                                  'bg-blue-200 text-blue-800'
                                }`}>{entry.status}</span>
                                {entry.status==='SCHEDULED'&&(
                                  <button onClick={e=>{e.stopPropagation();setAbsentForm({rosterId:entry.id,doctorName:`${row.doctor.first_name} ${row.doctor.last_name}`,reason:''});setShowAbsentForm(true);}}
                                    className="block mt-1 text-red-500 hover:text-red-700 hover:underline w-full text-center text-xs">Mark Absent</button>
                                )}
                              </div>
                            ):(
                              <button onClick={()=>openCellEditor(row.doctor,d,null)}
                                className={`w-full h-12 rounded-lg border-2 border-dashed transition-all flex flex-col items-center justify-center gap-0.5 ${
                                  hol?'border-yellow-300 text-yellow-500 hover:bg-yellow-50':
                                  isToday?'border-blue-300 text-blue-400 hover:bg-blue-50':
                                  'border-slate-200 text-slate-300 hover:border-blue-400 hover:text-blue-400 hover:bg-blue-50'
                                }`}>
                                <span className="text-base font-light leading-none">{hol?'H':'+'}</span>
                                {hol&&<span className="text-xs opacity-60 leading-none">Holiday</span>}
                              </button>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                    );
                  })}
                  {grid.length===0&&(
                    <tr><td colSpan={8} className="p-12 text-center text-slate-400">No doctors found. Add doctors in User Management first.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* SHIFT MASTER TAB */}
      {tab==='shifts'&&(
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-semibold text-slate-700">Shift Master ({shifts.length} shifts)</h3>
            <button onClick={()=>{setEditShiftId(null);setShiftForm({shiftName:'',shiftCode:'',startTime:'09:00',endTime:'13:00',slotDurationMinutes:15,maxPatients:20,overbookingLimit:0,color:'#3B82F6',consultationType:'OPD'});setShowShiftForm(true);}} className="btn-primary">➕ New Shift</button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {shifts.map((s:any)=>(
              <div key={s.id} className="card p-4" style={{borderLeft:`4px solid ${s.color||'#3B82F6'}`}}>
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-slate-800">{s.shift_name||s.shiftName}</p>
                    <p className="text-xs text-slate-400 font-mono">{s.shift_code||s.shiftCode}</p>
                  </div>
                  <button onClick={()=>{setEditShiftId(s.id);setShiftForm({shiftName:s.shift_name||s.shiftName,shiftCode:s.shift_code||s.shiftCode,startTime:s.start_time||s.startTime,endTime:s.end_time||s.endTime,slotDurationMinutes:s.slot_duration_minutes||s.slotDurationMinutes,maxPatients:s.max_patients||s.maxPatients,overbookingLimit:s.overbooking_limit||s.overbookingLimit,color:s.color,consultationType:s.consultation_type||s.consultationType});setShowShiftForm(true);}} className="text-xs text-[#02357A] hover:underline">Edit</button>
                </div>
                <div className="mt-2 space-y-0.5 text-xs text-slate-500">
                  <p>⏰ {s.start_time||s.startTime} – {s.end_time||s.endTime}</p>
                  <p>⏱️ {s.slot_duration_minutes||s.slotDurationMinutes} min slots · Max {s.max_patients||s.maxPatients} patients</p>
                  {(s.overbooking_limit||s.overbookingLimit)>0&&<p>📊 Overbook: +{s.overbooking_limit||s.overbookingLimit}</p>}
                  <p>🏷️ {s.consultation_type||s.consultationType}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* HOLIDAYS TAB */}
      {tab==='holidays'&&(
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-semibold text-slate-700">Hospital Holidays {new Date().getFullYear()}</h3>
            <button onClick={()=>setShowHolidayForm(true)} className="btn-primary">➕ Add Holiday</button>
          </div>
          <div className="card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 border-b"><tr>{['Date','Holiday','Type','Emergency Open',''].map(h=><th key={h} className="text-left p-3 text-xs font-semibold text-slate-500 uppercase">{h}</th>)}</tr></thead>
              <tbody className="divide-y">
                {holidays.map((h:any)=>(
                  <tr key={h.id} className="hover:bg-slate-50">
                    <td className="p-3 font-mono text-sm">{fmtDate(h.holiday_date||h.holidayDate)}</td>
                    <td className="p-3 font-medium">{h.holiday_name||h.holidayName}</td>
                    <td className="p-3"><Badge label={h.holiday_type||h.holidayType} className="bg-yellow-50 text-yellow-700"/></td>
                    <td className="p-3 text-center">{(h.is_emergency_open||h.isEmergencyOpen)?'✅':'❌'}</td>
                    <td className="p-3"><button onClick={()=>api.deleteHoliday(h.id).then(()=>{notify('Deleted');api.getHolidays().then(r=>setHolidays(r.data||[]));}).catch(()=>{})} className="text-xs text-red-500 hover:underline">Delete</button></td>
                  </tr>
                ))}
                {holidays.length===0&&<tr><td colSpan={5} className="p-8 text-center text-slate-400">No holidays added yet</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* BULK ASSIGN TAB */}
      {tab==='bulk'&&(
        <div className="card p-5 max-w-2xl">
          <h3 className="font-semibold text-slate-700 mb-4">Bulk Roster Assignment</h3>
          <div className="space-y-4">
            <div>
              <label className="label">Select Doctors *</label>
              <div className="border rounded-xl p-3 max-h-40 overflow-y-auto space-y-1">
                {doctors.map((d:any)=>(
                  <label key={d.id} className="flex items-center gap-2 text-sm cursor-pointer hover:bg-slate-50 px-2 py-1 rounded">
                    <input type="checkbox" checked={bulkForm.doctorIds.includes(d.id)} onChange={e=>{if(e.target.checked)setBulkForm({...bulkForm,doctorIds:[...bulkForm.doctorIds,d.id]});else setBulkForm({...bulkForm,doctorIds:bulkForm.doctorIds.filter(x=>x!==d.id)});}} className="w-4 h-4"/>
                    {d.firstName||d.first_name} {d.lastName||d.last_name}
                  </label>
                ))}
              </div>
              <p className="text-xs text-slate-400 mt-1">{bulkForm.doctorIds.length} doctors selected</p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><label className="label">Shift *</label>
                <Select value={bulkForm.shiftId} onChange={e=>setBulkForm({...bulkForm,shiftId:e.target.value})} required>
                  <option value="">Select shift...</option>
                  {shifts.map((s:any)=><option key={s.id} value={s.id}>{s.shift_name||s.shiftName} ({s.start_time||s.startTime}–{s.end_time||s.endTime})</option>)}
                </Select>
              </div>
              <div><label className="label">Recurring</label>
                <Select value={bulkForm.recurringType} onChange={e=>setBulkForm({...bulkForm,recurringType:e.target.value})}>
                  {[['DAILY','Every Day'],['WEEKDAYS','Mon–Fri'],['WEEKENDS','Weekends Only'],['MONDAY','Every Monday'],['ALTERNATE','Alternate Days']].map(([v,l])=><option key={v} value={v}>{l}</option>)}
                </Select>
              </div>
              <div><label className="label">From Date *</label><Input type="date" value={bulkForm.fromDate} onChange={e=>setBulkForm({...bulkForm,fromDate:e.target.value})}/></div>
              <div><label className="label">To Date *</label><Input type="date" value={bulkForm.toDate} onChange={e=>setBulkForm({...bulkForm,toDate:e.target.value})}/></div>
            </div>
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={bulkForm.skipHolidays} onChange={e=>setBulkForm({...bulkForm,skipHolidays:e.target.checked})} className="w-4 h-4"/> Skip hospital holidays</label>
            <div><label className="label">Remarks</label><Input value={bulkForm.remarks} onChange={e=>setBulkForm({...bulkForm,remarks:e.target.value})} placeholder="Optional note for this bulk assignment"/></div>
            <button onClick={saveBulkAssign} disabled={saving} className="btn-primary w-full">{saving?'Assigning...':'Assign Roster'}</button>
          </div>
        </div>
      )}

      {/* AUDIT LOG TAB */}
      {tab==='audit'&&(
        <div className="card overflow-hidden">
          <div className="p-4 border-b"><h3 className="font-semibold text-slate-700">Roster Audit Log</h3></div>
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b"><tr>{['Date/Time','Doctor','Action','Old','New','Changed By','Reason'].map(h=><th key={h} className="text-left p-3 text-xs font-semibold text-slate-500 uppercase">{h}</th>)}</tr></thead>
            <tbody className="divide-y">
              {audit.map((a:any)=>(
                <tr key={a.id} className="hover:bg-slate-50">
                  <td className="p-3 text-xs text-slate-400">{fmtDate(a.created_at||a.createdAt)}</td>
                  <td className="p-3 text-xs">{a.doctor_name||a.doctor_first_name?`Dr. ${a.doctor_first_name||''} ${a.doctor_last_name||''}`.trim():a.doctor_id?.slice(0,8)||'—'}</td>
                  <td className="p-3"><Badge label={a.action} className="bg-blue-50 text-[#02357A]"/></td>
                  <td className="p-3 text-xs">{a.old_status||'—'}</td>
                  <td className="p-3 text-xs">{a.new_status||'—'}</td>
                  <td className="p-3 text-xs">{a.changed_by_name||'—'}</td>
                  <td className="p-3 text-xs text-slate-500">{a.reason||'—'}</td>
                </tr>
              ))}
              {audit.length===0&&<tr><td colSpan={7} className="p-8 text-center text-slate-400">No audit entries yet</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {/* Cell Editor Modal */}
      <SlidePanel isOpen={!!editCell} onClose={()=>setEditCell(null)} title={editCell?`${editCell.doctor?.first_name} ${editCell.doctor?.last_name||''} — ${fmtDate(editCell.date)}`:''}>
        <div className="space-y-3">
          <div><label className="label">Shift</label>
            <Select value={cellForm.shiftId} onChange={e=>setCellForm({...cellForm,shiftId:e.target.value})}>
              <option value="">No shift (Off/Leave/Absent)</option>
              {shifts.map((s:any)=>(
                <option key={s.id} value={s.id} style={{color:s.color}}>{s.shift_name||s.shiftName} ({s.start_time||s.startTime}–{s.end_time||s.endTime}) · Max {s.max_patients||s.maxPatients} patients</option>
              ))}
            </Select>
          </div>
          <div><label className="label">Status</label>
            <Select value={cellForm.status} onChange={e=>setCellForm({...cellForm,status:e.target.value})}>
              {['SCHEDULED','PRESENT','ABSENT','LEAVE','OFF','HOLIDAY','EMERGENCY'].map(s=><option key={s}>{s}</option>)}
            </Select>
          </div>
          <div><label className="label">Remarks</label><Input value={cellForm.remarks} onChange={e=>setCellForm({...cellForm,remarks:e.target.value})} placeholder="Optional note"/></div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={cellForm.isEmergency} onChange={e=>setCellForm({...cellForm,isEmergency:e.target.checked})} className="w-4 h-4"/> Emergency Duty</label>
          <div className="flex gap-2">
            <button onClick={saveCellEntry} disabled={saving} className="btn-primary flex-1">{saving?'Saving...':'Save'}</button>
            {editCell?.existing&&<button onClick={()=>deleteEntry(editCell.existing.id)} className="btn-danger text-xs">Delete</button>}
            <button onClick={()=>setEditCell(null)} className="btn-secondary flex-1">Cancel</button>
          </div>
        </div>
      </SlidePanel>

      {/* Shift Form Modal */}
      <SlidePanel isOpen={showShiftForm} onClose={()=>setShowShiftForm(false)} title={editShiftId?'Edit Shift':'New Shift'}>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Shift Name *</label><Input value={shiftForm.shiftName} onChange={e=>setShiftForm({...shiftForm,shiftName:e.target.value})} placeholder="e.g. Morning OPD" required/></div>
            <div><label className="label">Code *</label><Input value={shiftForm.shiftCode} onChange={e=>setShiftForm({...shiftForm,shiftCode:e.target.value.toUpperCase()})} placeholder="e.g. MORNING" required/></div>
            <div><label className="label">Start Time *</label><Input type="time" value={shiftForm.startTime} onChange={e=>setShiftForm({...shiftForm,startTime:e.target.value})} required/></div>
            <div><label className="label">End Time *</label><Input type="time" value={shiftForm.endTime} onChange={e=>setShiftForm({...shiftForm,endTime:e.target.value})} required/></div>
            <div><label className="label">Slot Duration (min)</label><Input type="number" value={shiftForm.slotDurationMinutes} onChange={e=>setShiftForm({...shiftForm,slotDurationMinutes:+e.target.value})} min="5" max="60"/></div>
            <div><label className="label">Max Patients</label><Input type="number" value={shiftForm.maxPatients} onChange={e=>setShiftForm({...shiftForm,maxPatients:+e.target.value})} min="1"/></div>
            <div><label className="label">Overbooking Limit</label><Input type="number" value={shiftForm.overbookingLimit} onChange={e=>setShiftForm({...shiftForm,overbookingLimit:+e.target.value})} min="0"/></div>
            <div><label className="label">Color</label><input type="color" value={shiftForm.color} onChange={e=>setShiftForm({...shiftForm,color:e.target.value})} className="input h-10 p-1"/></div>
          </div>
          <div><label className="label">Consultation Type</label>
            <Select value={shiftForm.consultationType} onChange={e=>setShiftForm({...shiftForm,consultationType:e.target.value})}>
              {['OPD','EMERGENCY','IPD','TELECONSULTATION','PROCEDURE','OT'].map(t=><option key={t}>{t}</option>)}
            </Select>
          </div>
          <div className="text-xs text-slate-400 bg-slate-50 rounded p-2">
            Auto-generates slots: {shiftForm.startTime} → {shiftForm.endTime} every {shiftForm.slotDurationMinutes} min = {Math.floor(((+shiftForm.endTime.split(':')[0]*60+ +shiftForm.endTime.split(':')[1])-( +shiftForm.startTime.split(':')[0]*60+ +shiftForm.startTime.split(':')[1]))/shiftForm.slotDurationMinutes)} slots
          </div>
          <div className="flex gap-2">
            <button onClick={saveShift} disabled={saving} className="btn-primary flex-1">{saving?'Saving...':'Save Shift'}</button>
            <button onClick={()=>setShowShiftForm(false)} className="btn-secondary flex-1">Cancel</button>
          </div>
        </div>
      </SlidePanel>

      {/* Holiday Form Modal */}
      <SlidePanel isOpen={showHolidayForm} onClose={()=>setShowHolidayForm(false)} title="Add Holiday">
        <div className="space-y-3">
          <div><label className="label">Holiday Name *</label><Input value={holidayForm.holidayName} onChange={e=>setHolidayForm({...holidayForm,holidayName:e.target.value})} placeholder="e.g. Republic Day, Diwali"/></div>
          <div><label className="label">Date *</label><Input type="date" value={holidayForm.holidayDate} onChange={e=>setHolidayForm({...holidayForm,holidayDate:e.target.value})}/></div>
          <div><label className="label">Type</label>
            <Select value={holidayForm.holidayType} onChange={e=>setHolidayForm({...holidayForm,holidayType:e.target.value})}>
              {['NATIONAL','FESTIVAL','REGIONAL','HOSPITAL'].map(t=><option key={t}>{t}</option>)}
            </Select>
          </div>
          <div className="flex gap-2">
            <button onClick={saveHoliday} disabled={saving} className="btn-primary flex-1">{saving?'Saving...':'Add Holiday'}</button>
            <button onClick={()=>setShowHolidayForm(false)} className="btn-secondary flex-1">Cancel</button>
          </div>
        </div>
      </SlidePanel>

      {/* Conflict Detection Modal */}
      {conflictInfo&&(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-2xl">
            <h3 className="font-bold text-lg text-red-700 mb-3">⚠️ Shift Conflict Detected</h3>
            <p className="text-sm text-slate-600 mb-3">Dr. {conflictInfo.doctor?.first_name} already has a shift on {fmtDate(conflictInfo.date)}:</p>
            {(conflictInfo.conflicts||[]).map((c:any,i:number)=>(
              <div key={i} className="bg-red-50 rounded p-2 text-xs mb-2">
                <span className="font-semibold">{c.shift_name}</span> · {c.start_time}–{c.end_time}
              </div>
            ))}
            <div className="flex gap-2 mt-4">
              <button onClick={()=>{doSaveEntry(conflictInfo.pendingForm);}} className="btn-danger flex-1 text-sm">Override Anyway</button>
              <button onClick={()=>setConflictInfo(null)} className="btn-secondary flex-1 text-sm">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Mark Absent Modal */}
      <SlidePanel isOpen={showAbsentForm} onClose={()=>setShowAbsentForm(false)} title="Mark Doctor Absent">
        <div className="space-y-3">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
            <p className="font-semibold">{absentForm.doctorName}</p>
            <p className="text-xs mt-1">⚠️ All slots will be blocked and patients will be notified for rescheduling</p>
          </div>
          <div><label className="label">Reason *</label>
            <Select value={absentForm.reason} onChange={e=>setAbsentForm({...absentForm,reason:e.target.value})}>
              <option value="">Select reason...</option>
              {['Personal Emergency','Medical Leave','Training/Conference','Official Duty','Without Intimation','Other'].map(r=><option key={r}>{r}</option>)}
            </Select>
          </div>
          <div className="flex gap-2">
            <button onClick={markAbsentWithNotif} disabled={saving||!absentForm.reason} className="btn-danger flex-1">{saving?'Processing...':'Mark Absent & Notify'}</button>
            <button onClick={()=>setShowAbsentForm(false)} className="btn-secondary flex-1">Cancel</button>
          </div>
        </div>
      </SlidePanel>

      {/* Emergency Override Modal */}
      <SlidePanel isOpen={showEmergencyForm} onClose={()=>setShowEmergencyForm(false)} title="🚨 Emergency Duty Override">
        <div className="space-y-3">
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-xs text-red-700">
            This overrides normal schedule rules — for genuine emergencies only. Full audit trail maintained.
          </div>
          <div><label className="label">Doctor *</label>
            <Select value={emergencyForm.doctorId} onChange={e=>setEmergencyForm({...emergencyForm,doctorId:e.target.value})} required>
              <option value="">Select doctor...</option>
              {doctors.map((d:any)=><option key={d.id} value={d.id}>{d.firstName||d.first_name} {d.lastName||d.last_name}</option>)}
            </Select>
          </div>
          <div><label className="label">Shift *</label>
            <Select value={emergencyForm.shiftId} onChange={e=>setEmergencyForm({...emergencyForm,shiftId:e.target.value})} required>
              <option value="">Select shift...</option>
              {shifts.map((s:any)=><option key={s.id} value={s.id}>{s.shift_name||s.shiftName} ({s.start_time||s.startTime}–{s.end_time||s.endTime})</option>)}
            </Select>
          </div>
          <div><label className="label">Date *</label><Input type="date" value={emergencyForm.rosterDate} onChange={e=>setEmergencyForm({...emergencyForm,rosterDate:e.target.value})}/></div>
          <div><label className="label">Reason for Override *</label><Input value={emergencyForm.reason} onChange={e=>setEmergencyForm({...emergencyForm,reason:e.target.value})} placeholder="Code Blue, Mass Casualty, Doctor absent last minute..."/></div>
          <div className="flex gap-2">
            <button onClick={doEmergencyOverride} disabled={saving} className="btn-danger flex-1">{saving?'Assigning...':'🚨 Override & Assign Emergency Duty'}</button>
            <button onClick={()=>setShowEmergencyForm(false)} className="btn-secondary flex-1">Cancel</button>
          </div>
        </div>
      </SlidePanel>
    </Layout>
  );
}
